import { useTracks, LayoutContextProvider, TrackLoop, ControlBar } from "@livekit/components-react";
import { Track } from "livekit-client";

import { ParticipantAudioTile } from "./VoiceChatParticipantAudioTile";

export default function VoiceChatContent() {
	// NOW this is safe - we're inside the LiveKitRoom context
	const audioTracks = useTracks([Track.Source.Microphone]);

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const ParticipantAudioTileComponent = ParticipantAudioTile as any;

	return (
		<LayoutContextProvider>
			<div className="min-w-full min-h-full ">
				<div className="min-w-full min-h-full gap-2 flex! flex-col bg-white">
					<TrackLoop tracks={audioTracks}>
						<ParticipantAudioTileComponent />
					</TrackLoop>
				</div>
				<ControlBar
					className={`bg-white transition-all delay-200 `}
					controls={{
						microphone: true,
						leave: true,
						screenShare: false,
						camera: false,
						chat: false,
					}}
				/>
			</div>
		</LayoutContextProvider>
	);
}
